import api from './api';
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// Create axios instance with default config
// const api = axios.create({
//   baseURL: API_URL,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

const adminService = {
  // ============================================================================
  // SYSTEM ADMIN OPERATIONS (role_id = 2)
  // ============================================================================

  // Get all system admins
  getAllAdmins: async (params = {}) => {
    const response = await api.get('/admins', { params });
    return response;
  },

  // Get system admin by ID
  getSystemAdmin: async (adminId) => {
    const response = await api.get(`/admins/${adminId}`);
    return response;
  },

  // Create system admin
  createSystemAdmin: async (adminData) => {
    const response = await api.post('/admins', adminData);
    return response;
  },

  // Update system admin
  updateSystemAdmin: async (adminId, adminData) => {
    const response = await api.put(`/admins/${adminId}`, adminData);
    return response;
  },

  // Delete system admin
  deleteSystemAdmin: async (adminId) => {
    const response = await api.delete(`/admins/${adminId}`);
    return response;
  },

  // ============================================================================
  // PRACTICE ADMIN OPERATIONS (role_id = 3)
  // ============================================================================

  // Create practice admin
  createAdmin: async (practiceId, adminData) => {
    const response = await api.post(`/practices/${practiceId}/admins`, adminData);
    return response;
  },

  // Get all admins for a practice
  getAdmins: async (practiceId, params = {}) => {
    const response = await api.get(`/practices/${practiceId}/admins`, { params });
    return response;
  },

  // Get admin by ID
  getAdmin: async (practiceId, adminId) => {
    const response = await api.get(`/practices/${practiceId}/admins/${adminId}`);
    return response;
  },

  // Update admin
  updateAdmin: async (practiceId, adminId, adminData) => {
    const response = await api.put(`/practices/${practiceId}/admins/${adminId}`, adminData);
    return response;
  },

  // Delete admin
  deleteAdmin: async (practiceId, adminId) => {
    const response = await api.delete(`/practices/${practiceId}/admins/${adminId}`);
    return response;
  }
};

export default adminService;
